import { render } from "./ImageFieldEditor.vue?vue&type=template&id=016c57e7&scoped=true"
import script from "./ImageFieldEditor.vue?vue&type=script&lang=js"
export * from "./ImageFieldEditor.vue?vue&type=script&lang=js"

import "./ImageFieldEditor.vue?vue&type=style&index=0&id=016c57e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016c57e7"]])

export default __exports__